import { useEffect, useRef } from "react";
import Http from "api/Http";
import { useDispatch } from "react-redux";
import { setRedirectUrl } from "store/slices/applicationSlice";
import { useHistory } from "react-router-dom";
// Layouts
import FullPageMessage from "layouts/FullPageMessage";

// Styles
import "./LoggingOutPage.scss";
export default function LoggingOutPage(props) {
  const { isTwoFactorRegisterPage } = props;
  const urlParams = new URLSearchParams(window.location.search);
  const iframeRef = useRef(null);
  const iframeUri = urlParams.get("iframeUri") || "";
  const logoutId = urlParams.get("logoutId") || "";
  const redirectUri = urlParams.get("redirectUri") || "/";
  const logoutUri = urlParams.get("logoutUrl") || "";

  const reduxDispatch = useDispatch();
  const history = useHistory();

  const isValidURL = string => {
    try {
      let base = "http://relativebase";
      if (!base.endsWith("/")) {
        base += "/";
      }
      let url = new URL(string, base);
      return url.protocol === "http:" || url.protocol === "https:";
    } catch {
      return false;
    }
  };

  const performLogoutAndRedirect = async () => {
    try {
      if (isTwoFactorRegisterPage && isValidURL(logoutUri)) {
        await fetch(logoutUri, { method: "GET", credentials: "include" });
      }
    } catch (error) {
      console.error("Fetch logout failed:", error);
    }

    try {
      const data = logoutId ? { logoutId } : undefined;
      await Http.post({
        url: "Interaction/Logout",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        data,
        excludeApiPrefix: true,
      });
    } catch (error) {
      console.error("Logout failed", error);
    }

    if (isTwoFactorRegisterPage && isValidURL(redirectUri)) {
      reduxDispatch(setRedirectUrl(redirectUri));
    }
    redirect();
  };

  const redirect = () => {
    if (isTwoFactorRegisterPage) {
      history.push("/");
      return;
    }

    if (isValidURL(redirectUri)) {
      window.location.href = redirectUri;
      return;
    }
    window.location.href = "/";
  };

  useEffect(() => {
    if (iframeUri === "") {
      performLogoutAndRedirect();
    } else {
      const iframe = iframeRef.current;
      const handleLoad = () => performLogoutAndRedirect();
      iframe.addEventListener("load", handleLoad);
      return () => iframe.removeEventListener("load", handleLoad);
    }
  }, [iframeUri]);

  if (iframeUri === "") return null;

  return (
    <FullPageMessage>
      <div className="logging-out-content">
        <p className="navyBlue">Logging out...</p>
        <iframe
          ref={iframeRef}
          src={iframeUri}
          title="logout"
          style={{
            visibility: "invisible",
            height: 0,
            width: 0,
          }}
        />
      </div>
    </FullPageMessage>
  );
}
